
































































































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { State, Action, Getter } from "vuex-class";
import { FinancialReportData } from "@/entities";
import { AppConstants as _app } from "@/shared/app.constants";
import HeaderInfo from "../../ExpansionPanel/FinExpansionPanel.vue";
import NavButtons from "@/components/common/Buttons/NavButtons.vue";
import TableComponent from "./Components/CashFlowProjectionTable.vue";

const namespace: string = "financialReport";
@Component({
  components: {
    HeaderInfo,
    NavButtons,
    TableComponent,
  },
})
export default class CashFlowProjectionComponent extends Vue {
  @State(namespace) financialReport!: FinancialReportData;
  @Getter("selectedReport", { namespace }) report: any;
  @Getter("grantInfo", { namespace }) grantInfo: any;

  @Prop() financialReportSections: any;
  @Prop() model: any;
  @Prop() schema: any;
  @Prop() isFinalReport: boolean;
  @Prop() currency: string;
  @Prop() formOptions: any;
  @Prop() isDirty: any;
  @Prop() workFlowItems: any;
  @Prop() preValidation: any;
  @Prop() entity: any;
  @Prop() enableButton: any;
  @Prop() validations: any;

  mounted() {}

  getFeedbackHeader(rowKey) {
    if (this.formOptions && this.formOptions.feedbacks) {
      return this.formOptions.feedbacks.find((x) => x.RowKey === rowKey);
    } else {
      return null;
    }
  }

  get budgetCategories() {
    return this.financialReport.categories;
  }

  get dataModel() {
    if (
      !this.model.cashFlowProjection ||
      this.model.cashFlowProjection.length == 0
    ) {
      this.model.cashFlowProjection = [];
      let prevCashFlow: Array<any> = [];

      // get currently selcted report
      let selReport = this.financialReport.selectedReport;

      // get previous report cashflow data
      let prevReports =
        this.financialReport.grantData.finReport.filter(
          (x) => x.FinancialReportId < selReport.FinancialReportId
        ) || [];

      if (prevReports && prevReports.length > 0) {
        let prevReport = prevReports.slice(-1);
        prevCashFlow = prevReport[0].cashFlowProjection || [];
      }

      this.budgetCategories.forEach((cat) => {
        let row: any = {};
        let cashFlowRow =
          prevCashFlow.find((x) => x.categoryId == cat.id) || {};

        row.categoryId = cat.id;

        this.financialReport.finReports
          .filter((x) => x.FinancialReportId > selReport.FinancialReportId)
          .forEach((period) => {
            row[period.FinancialReportId] =
              cashFlowRow[period.FinancialReportId] || 0;
          });

        this.model.cashFlowProjection.push(row);
      });
    }

    return this.model.cashFlowProjection;
  }
}
